<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="经理名称" name="name">
                <a-input v-model:value="searchForm.name" placeholder="请输入总资产"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #headImg="{record}">
                <div  style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.headImg" :showList="true" disabled />
                </div>
            </template>
            <template #auditStatus="{ text }">
                <dict-render :dict-obj="dictObjs['aduit_status']" :text="text"></dict-render>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {tableListMixin, dictMixin} from "@/mixins";
import {financeInvestorManager} from "@/api/finance";
import DictRender from "@/components/other/DictRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "头像", dataIndex: "headImg", key: "headImg", slots: { customRender: "headImg" }},
    {title: "经理名称", dataIndex: "name", key: "name"},
    {title: "联系电话", dataIndex: "contactNumber", key: "contactNumber"},
    // {title: "审核状态", dataIndex: "auditStatus", key: "auditStatus", slots: { customRender: "auditStatus" }},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "融资需求",
    mixins: [tableListMixin,dictMixin],
    components: {
        AddOrEditModal,
        DictRender
    },
    data() {
        return {
            dictNames: 'aduit_status',
            columns,
            queryParam: {},
            listUrl: financeInvestorManager.pageList,
            listKeyField: "id",
            deleteUrl: financeInvestorManager.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeInvestorManager.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
